<template>
  
<v-navigation-drawer v-model="drawer" width="250" dark clipped fixed left disable-resize-watcher app>
    

    <v-list>
      
        <v-list-tile router-link to="/live">
            <!-- <v-list-tile-action>
                <v-icon>home</v-icon>
            </v-list-tile-action> -->
            <v-list-tile-content>
                <v-list-tile-title>Live</v-list-tile-title>
            </v-list-tile-content>

        </v-list-tile>

        <v-list-tile router-link to="/breakouts">

            <v-list-tile-content>
                <v-list-tile-title>Breakout Sessions</v-list-tile-title>
            </v-list-tile-content>

        </v-list-tile>
    </v-list>
 
</v-navigation-drawer>

</template>

<script>

    import { mapState } from 'vuex';

    export default {
        props: [],
        data(){  
            return {}
        },
        created(){

         },
        mounted() {
           // console.log('Brands mounted.')
        },
        computed: {
            ...mapState({
                drawerFromStore: 'drawer'
            }),
            drawer: {
                get(){
                    return this.drawerFromStore
                },
                set(newDrawer){
                    return newDrawer
                }
            }
        },
        methods: {
  
             toggleDrawer(){
                this.$store.dispatch('toggleDrawer');
            }
        }
    }
</script>

<style scoped>


.v-list__tile__action {
    min-width: 35px;
}

.v-icon {
    color: #8edfb4;
}


.v-list__tile__title {
    font-weight: 700; 
    font-size: 21px;
    color: #fff;
}

</style>